var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c('div',{staticClass:"d-flex justify-center",attrs:{"id":"print-me"}},[_c('div',{staticClass:"rounded-lg white elevation-7 pa-3"},[(_vm.ticket)?_c('TicketPrintCard',{attrs:{"ticket":_vm.ticket}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }